import React from "react"
import {
  Box,
  Button,
  CircularProgress,
  styled,
  Typography
} from "@mui/material"
import ChevronLeft from '@mui/icons-material/ChevronLeft'

import { colors, interpolateColor } from "../../../utils/colorUtils"
import config from "../../../config"
import charcoalPanel from "../../../assets/texturedPanelCharcoal75.jpg"
import greenPanel from "../../../assets/texturedPanelGreen.jpg"

const ExpandablePanel = styled(Box)(({ background, color, width }) => ({
  backgroundImage: background,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundColor: color,
  display: 'flex',
  overflow: 'auto',
  width,
}))

const Label = styled(Typography)(
  ({
    backgroundColor,
    padding,
    visibility,
    width
  }) => ({
    backgroundColor,
    boxSizing: 'unset',
    color: colors.awaOffWhite,
    padding,
    paddingBottom: '10px',
    textAlign: 'right',
    textTransform: 'uppercase',
    transform: 'rotate(180deg)',
    visibility,
    width,
    writingMode: 'vertical-lr',
    ':hover': { cursor: 'pointer' },
  })
)

const ContentPanel = styled(Box)(({ background, padding, width }) => ({
  animationName: 'width 2s',
  background,
  padding,
  width,
}))

const ContentLabel = styled(Box)(({ background }) => ({
  background,
  padding: '0 5px 5px 5px',
  textTransform: 'uppercase',
  ':hover': { cursor: 'pointer' },
}))

const ContentLabelButton = ({
  onClick,
  sx,
}) => (
  <Button
    onClick={(e) => {
      e.stopPropagation()
      onClick()
    }}
    sx={{
      color: colors.awaOffWhite,
      float: 'right',
      fontSize: '0.7rem',
      fontWeight: 400,
      mt: 1,
      mr: 1,
      p: 0.125,
      textTransform: 'uppercase',
      ...sx,
    }}
  >
    clear
  </Button>
)

const Panel = ({
  children,
  contentLabelBackground,
  contentLabelButtonProps,
  contentPanelBackground,
  expanded,
  label,
  labelColor = colors.awaCharcoal75,
  labelImage = '',
  loading = false,
  panelCollapseWidth = config.panelCollapseWidth,
  // panelColor = colors.awaCharcoal + opacity.a15,
  setExpanded,
}) => (
  <ExpandablePanel
    background={labelImage}
    // color={panelColor}
    width={`${expanded ? panelCollapseWidth : config.panelLabelWidth}px`}
  >
    <Label
      // backgroundColor={labelColor}
      padding={`${expanded ? 0 : 5}px`}
      visibility={expanded ? 'hidden' : 'visible'}
      width={`${expanded ? 0 : config.panelLabelWidth}px`}
      onClick={() => { setExpanded(f => !f) }}
    >
      {loading && <CircularProgress
        sx={{ color: colors.awaOffWhite, mb: 2 }}
        size={14.4}
      />}
      {label}
    </Label>
    <ContentPanel
      background={contentPanelBackground}
      width={expanded ? '100%' : 0}
    >
      {expanded &&
        <>
          <ContentLabel
            background={contentLabelBackground}
            backgroundColor={labelColor}
            color={colors.awaOffWhite}
            onClick={() => { setExpanded(f => !f) }}
          >
            <ChevronLeft
              color={colors.awaOffWhite}
              viewBox={"0 -6 24 24"}
            />
            {label}
            {loading && <>
              {"  "}
              <CircularProgress
                sx={{ color: colors.awaOffWhite }}
                size={12.8}
              />
            </>}
            <ContentLabelButton {...contentLabelButtonProps} />
          </ContentLabel>
          <Box sx={{ p: 1 }}>
            {children}
          </Box>
        </>
      }
    </ContentPanel>
  </ExpandablePanel>
)


// TEST ONLY

const sharedLabelColor = interpolateColor(
  colors.awaCharcoal75,
  colors.awaGreen,
  0.5
)
const sharedPanelColor = interpolateColor(
  colors.awaCharcoal15,
  colors.awaGreen15,
  0.5
)

const DataPanel = (props) => <Panel
  {...props}
  labelImage={`url(${greenPanel})`}
  contentLabelBackground={
    `linear-gradient(.25turn, ${sharedLabelColor}, 10%, ${colors.awaGreen})`
  }
  contentPanelBackground={
    `linear-gradient(.25turn, ${sharedPanelColor}, 10%, ${colors.awaGreen15})`
  }
  label='Datasets'
  labelColor={colors.awaGreen}
  panelColor={colors.awaGreen15}
/>


const FilterPanel = (props) => <Panel
  {...props}
  labelImage={`url(${charcoalPanel})`}
  contentLabelBackground={
    `linear-gradient(.25turn, ${colors.awaCharcoal75}, 90%, ${sharedLabelColor})`
  }
  contentPanelBackground={
    `linear-gradient(.25turn, ${colors.awaCharcoal15}, 90%, ${sharedPanelColor})`
  }
  label='Filters'
/>

export {
  DataPanel,
  FilterPanel,
  Panel as default,
}